import React from 'react';

import type { SideNavigationItemProps } from '@lumapps/lumx-back-office/components/SideNavigation';
import { isPlayVideoEnabled } from '@lumapps/play/ducks/selectors';
import { useSelector } from '@lumapps/redux/react';

import { VideoUsageSideNavigation as VideoUsageComponent } from './VideoUsageSideNavigation';

const VideoUsageSideNavigation: React.FC<Partial<SideNavigationItemProps>> = (props) => {
    const isAllowed = useSelector(isPlayVideoEnabled);

    return <VideoUsageComponent {...props} isAllowed={isAllowed} />;
};

export default VideoUsageSideNavigation;
